import type { INotificationSettingsResponse } from './models/NotificationSettingsResponse';

/** Canonical SPA path for the “generated notifications” grid (GridUrl in Umbraco may differ). */
export const NOTIFICATION_GENERATED_GRID_APP_PATH = '/notifications';
export const NOTIFICATIONS_UPDATED_EVENT = 'notifications:updated';

const CRM_GENERATED_NOTIFICATION = 'CrmGeneratedNotification';

export function getGeneratedNotificationGridKey(
  settings: INotificationSettingsResponse | undefined
): string | undefined {
  const links = settings?.EntityLinks;
  if (!Array.isArray(links)) return undefined;
  const key = links.find((l) => l.DataSource === CRM_GENERATED_NOTIFICATION)?.GridKey;
  return key && String(key).length > 0 ? String(key) : undefined;
}

export function getGeneratedNotificationGridUrl(
  settings: INotificationSettingsResponse | undefined
): string | undefined {
  const links = settings?.EntityLinks;
  if (!Array.isArray(links)) return undefined;
  const url = links.find((l) => l.DataSource === CRM_GENERATED_NOTIFICATION)?.GridUrl;
  return url && String(url).length > 0 ? String(url) : undefined;
}

export function emitNotificationsUpdatedEvent(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(NOTIFICATIONS_UPDATED_EVENT));
}
